import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createInvoiceTaxAuthorityConfig } from 'Services/invoices';

export default function useCreateInvoiceTaxAuthorityConfig() {
    const queryClient = useQueryClient();

    const { mutateAsync, isPending } = useMutation({
        mutationFn: (params) => createInvoiceTaxAuthorityConfig(params),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['invoices', 'tax-authority-configs'] });
        },
    });

    return { createConfig: mutateAsync, isPending };
}
